"use client";

import SharedLink from "@casino/shared/components/Link";
import useSiteInfo from "@workspace/nextjs_utils/src/siteInfo/useSiteInfo";
import type { LinkProps } from "next/link";

type Props = Omit<LinkProps, "locale"> & {
  className?: string;
  target?: "_blank";
};

const Link: FC<Props> = (props) => {
  const { isBridgeSite, defaultLang, language, domain } = useSiteInfo();
  return (
    <SharedLink
      {...props}
      isBridgeSite={isBridgeSite}
      language={language}
      domain={domain}
      defaultLang={defaultLang}
    />
  );
};

export default Link;
